export const URL_KEYS = {
    ABBA_PREVIEW_KEY: "abbaPreview",
    ABBA_MOCK_USERINFO_KEY: "mockUserInfo",
    ABBA_MOCK_CONTEXTINFO_KEY: "mockContextInfo",
    ABBA_MOCK_TAGSINFO_KEY: "mockTagsInfo",
    ABBA_MOCK_URLINFO_KEY: "mockUrlInfo",
    ABBA_MOCK_CONTENT_METADATA: "mockContentMetadata",
};
